import { defineComponent as _defineComponent } from 'vue'
import type { GetPopularTitlesQueryVariables } from '@/pages/graphql/queries/GetPopularTitles.query';

import { ModalHelper } from '@/helpers/modal-helper';

import ReelModal from '@/components/experiments/ReelsExp/components/ReelModal.vue';
import ReelsExp from '../index';
import { useReelsExp } from './query';

import { computed } from 'vue';
import { faPlay } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelModalBanner',
  props: {
    queryVariables: null
  },
  setup(__props: any) {

const props = __props as {
	queryVariables: GetPopularTitlesQueryVariables;
};



const { activeReelExpVariant } = useReelsExp();
const activateVariant = computed(() => activeReelExpVariant.value === 'variant_3');

function openModal() {
	ReelsExp.trackEvent({
		action: 'impression',
		property: 'shorts_popular',
	});
	ReelsExp.trackEvent({
		action: 'click',
		label: 'video_player_open',
		property: 'shorts_popular',
	});
	ModalHelper.openModal(
		ReelModal,
		{
			queryVariables: props.queryVariables,
			title: '',
		},
		{ cssClass: 'reel-modal' }
	);
}

return { __sfc: true,props, activeReelExpVariant, activateVariant, openModal, faPlay }
}

})